import { Component, Input, OnChanges, OnInit, Optional, Self } from '@angular/core';

import { ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { LexSelectComponent } from '../lex-select/lex-select.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-autocomplete',
  templateUrl: './lex-autocomplete.component.html',
  styleUrls: ['./lex-autocomplete.component.scss'],
  standalone: false,
})
export class LexAutocompleteComponent
  extends LexSelectComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() allowCustom: boolean;

  filteredOptions: Observable<any[]>;

  autocompleteControl = new UntypedFormControl();
  valueInternal;

  @Input() optionsFilter: (value, options) => any[] = (value, options) =>
    options.filter((o) => o.label.includes(value));

  constructor(@Self() @Optional() public ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes) {
    super.ngOnChanges(changes);

    if (changes.value) {
      if (!changes.value.currentValue) {
        this.autocompleteControl.setValue('');
      }

      this.setInternalValue();
    }

    if (changes.options && changes.options.currentValue) {
      this.filteredOptions = this.autocompleteControl.valueChanges.pipe(
        startWith(''),
        debounceTime(200),
        map((value) => {
          if (typeof value === 'string') {
            return value;
          } else if (value) {
            return this.labelFormatter(value);
          }
          return undefined;
        }),
        map((value) => (value ? this.optionsFilter(value, this.options) : this.options.slice()))
      );

      this.setInternalValue();
    }
  }

  private setInternalValue() {
    if (
      this.allowCustom &&
      this.value &&
      (!this.valueInternal || this.value !== this.valueInternal)
    ) {
      this.valueInternal = this.value;
      this.autocompleteControl.setValue(this.valueInternal);
    } else if (
      this.options &&
      this.value &&
      (!this.valueInternal || this.value !== this.valueAccessor(this.valueInternal))
    ) {
      this.valueInternal = this.options.find((opt) => this.value === this.valueAccessor(opt));
      this.autocompleteControl.setValue(this.valueInternal);
    }
  }

  updateDisabled() {
    super.updateDisabled();

    if (this.disabled) {
      this.autocompleteControl.disable();
    } else {
      this.autocompleteControl.enable();
    }
  }

  displayFn() {
    return (item) => (item ? this.labelFormatter(item) : item);
  }

  onValueEntered($event) {
    if (this.allowCustom) {
      this.valueInternal = $event.target.value;
      this.control.setValue($event.target.value);
    }
  }

  onOptionSelected($event) {
    this.valueInternal = $event.option.value;
    this.control.setValue(
      $event.option.value ? this.valueAccessor($event.option.value) : undefined
    );
  }
}
